import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cx from 'classnames';

const propTypes = {
  number: PropTypes.number,
  className: PropTypes.string,
};

const defaultProps = {
  number: 5,
  className: '',
};

const stars = (number) => {
  const rows = [];
  for (let i = 0; i < number; i+=1) {
    rows.push(<span className="icon-star" key={`star${i}`} />);
  }
  return rows;
};

class Stars extends PureComponent {
  render() {
    const { number, className } = this.props;

    return (
      <div className={cx('stars', className)} style={{ color: '#FFC603', fontSize: 25 }}>{ stars(number) }</div>
    );
  }
}

Stars.propTypes = propTypes;
Stars.defaultProps = defaultProps;
export default Stars;
